import { Breakpoint, useTheme } from '@mui/material/styles';
import { CSSProperties } from 'react';

export const useSectionFieldStyles = (
	collapseAt: Breakpoint = 'md',
	labelWidth: CSSProperties['width'] = '300px'
) => {
	const theme = useTheme();

	return {
		fieldContainer: {
			display: 'flex',
			columnGap: 1,
			flexDirection: 'row',

			[theme.breakpoints.down(collapseAt)]: {
				flexDirection: 'column'
			}
		},

		label: {
			maxWidth: labelWidth ?? '',
			minWidth: labelWidth ?? '',

			whiteSpace: 'normal',
			overflowWrap: 'anywhere',
			wordBreak: 'break-word',
			color: 'text.fadedPrimary',
			fontWeight: 700,
			fontSize: '1rem',
			lineHeight: 'unset',

			[theme.breakpoints.down(collapseAt)]: {
				width: '100%',
				maxWidth: '100%',
				minWidth: 'unset',
				fontWeight: '700 !important'
			}
		},

		valueContainer: {
			display: 'flex',
			flexDirection: 'column',
			gap: 1,
			maxWidth: `calc(100% - ${labelWidth} - var(--mui-spacing))`,

			[theme.breakpoints.down(collapseAt)]: {
				maxWidth: '100%'
			}
		},

		value: (isLink: boolean) => ({
			color: 'text.fadedPrimary',
			fontWeight: 400,
			fontSize: '1rem',
			flexWrap: 'wrap',
			overflowWrap: isLink ? 'unset' : 'break-word',
			overflow: 'hidden',
			textOverflow: 'ellipsis',
			whiteSpace: isLink ? 'nowrap' : 'normal',
			display: 'block',
			maxWidth: isLink ? '42ch' : 'unset',
			lineHeight: 'unset'
		}),

		groupName: {
			color: 'text.secondary',
			fontWeight: 400,
			fontSize: '0.75rem',
			marginBottom: -1
		}
	};
};
